import mesureEnum from "@/model/mesureEnum";
import dimensionEnum from "@/model/dimensionEnum";
import _ from "lodash";
import i18n from "@/plugins/vue-i18n.js";

export const staffHelper = {

  dimensions: [
    dimensionEnum.EMPLOYEE,
    dimensionEnum.EMPLOYEE_FIRSTNAME,
    dimensionEnum.EMPLOYEE_LASTNAME,
    dimensionEnum.EMPLOYEE_ROLE,
    dimensionEnum.SITE,
    dimensionEnum.SITE_NAME,
    dimensionEnum.SITE_CURRENCY,
  ],

  getQueries(filters) {
    const queries = [
      {
        query: {
          measures: [
            mesureEnum.STAFFGAMEHISTORY_COUNT,
            mesureEnum.STAFFGAMEHISTORY_TOKENCREDITED,
            mesureEnum.STAFFGAMEHISTORY_REVENUE_EQUIVALENT_TTC,
          ],
          dimensions: this.dimensions.concat([
            dimensionEnum.STAFFGAMEHISTORY_CARDNUMBER
          ]),
          filters: filters,
        },
      },
      {
        query: {
          measures: [
            mesureEnum.ADJUSTMENTHISTORY_COUNT,
            mesureEnum.ADJUSTMENTHISTORY_AMOUNT,
          ],
          dimensions: this.dimensions,
          filters: filters,
        },
      }
    ];
    return queries;
  },
  addDimensionsTotals(dataTable, totalsData) {
    //Comptage des différents rôles
    let groupby = _.groupBy(
      dataTable,
      dimensionEnum.EMPLOYEE_ROLE
    ),
      distinct = Object.keys(groupby)
        .map((key) => groupby[key].length + " " + key)
        .join("<br/>");
    totalsData[dimensionEnum.EMPLOYEE_ROLE] = distinct;

    // Nombre de cartes actives
    // On ne compte que les lignes qui possedent une carte (avec parties lancées)
    let nbActiveCards = dataTable.filter(dt => dt[dimensionEnum.STAFFGAMEHISTORY_CARDNUMBER]).length;
    totalsData[dimensionEnum.STAFFGAMEHISTORY_CARDNUMBER] = i18n.t("StaffGameHistory.nbactivecards").format(nbActiveCards, nbActiveCards > 1 ? "s" : "");

    return totalsData;
  },
};